
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M49 24.5C49 38.03 38.032 49 24.5 49S0 38.03 0 24.5 10.968 0 24.5 0 49 10.97 49 24.5z","fill":"#005149"}}),_c('path',{attrs:{"d":"M15 10c1.657 0 3 1.456 3 3.25 0 1.796-1.343 3.251-3 3.251s-3-1.455-3-3.25S13.343 10 15 10zm-2.591 27h5.176V18.962h-5.176V37zM20 18.46h5.525v2.535h.103a6.061 6.061 0 015.456-2.99c5.848 0 6.916 3.837 6.916 8.826V37h-5.764v-9.013c0-2.15-.034-4.918-2.995-4.918-2.957 0-3.46 2.336-3.46 4.761V37h-5.758L20 18.46z","fill":"#FFF"}})])])
          )
        }
      }
    